import { createTheme, ThemeProvider } from "@mui/material/styles";
import _ from "lodash";
import React, { createRef, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { bindActionCreators } from "redux";
import * as providerActionCreators from "./actions";
import { CsvBuilder } from "filefy";
import AllOrdersPageHeader from "./allOrdersPageHeader/allOrdersPageHeader";
import AllOrdersMaterialTable from "./allOrdersMaterialTable/allOrdersMaterialTable";
import AllOrdersDialog from "./allOrdersDialog/allOrdersDialog";
import { allOrdersData } from "./api";
import LoaderComponent from "../../LoaderComponent/LoaderComponent";
import { toast } from "react-toastify";
import { log } from "../../Helper";
import { useUserInfo } from "../../common/user-context";
// import { columns } from "./Constants";

const tableRef = createRef();

export const Orders = () => {
  const { userData } = useUserInfo();

  //all useStates

  const [openYear, setOpenYear] = useState(false);
  const [isInternal, setIsInternal] = useState(false);
  const [tableData, setTableData] = useState(Array(0));
  const [previousForwarder, setPreviousForwarder] = useState();
  const [isLoading, setLoading] = useState(false);
  const [columns, setColumns] = useState([]);

  // all the selectors

  const { setProvider } = bindActionCreators(
    providerActionCreators,
    useDispatch()
  );
  const providerList = useSelector((storeState) => storeState.getProviderList);
  const supplierId_withForwarder = userData.supplierNumber;

  const supplierName = userData.descr;


  let supplierId_WithInternal = useSelector(
    (storeState) => storeState.setProvider
  );

  // dom functions
  const handleOpenYearDialog = () => {
    if (openYear) {
      setOpenYear(false);
    } else {
      setOpenYear(true);
    }
  };

  const exportCsv = (columns, data, selectedYear) => {
    if (data) {
      handleOpenYearDialog();
      const columnTitles = columns.map((columnDef) => columnDef.title);
      const csvData = data
        .filter((data1) => {
          const year = data1.FORWARDER_INFORMED
            ? data1.FORWARDER_INFORMED.slice(0, 4)
            : new Date().getFullYear().toString();
          return _.isEqual(year.toString(), selectedYear.toString());
        })
        .map((rowData) => columns.map((columnDef) => rowData[columnDef.field]));

      const builder = new CsvBuilder(`data.csv`)
        .setColumns(columnTitles)
        .addRows(csvData)
        .exportFile();

      return builder;
    }
  };
  const handleTableRefresh = () => {
    tableRef.current.state.query.orderBy = null;
    tableRef.current.state.query.orderDirection = "";
    getTableData();
  };
  
  const theme = createTheme({
    palette: {
      primary: {
        main: '#367C2B', // Green
      },
      secondary: {
        main: '#FFDE00', // Yellow
      },
      text: {
        primary: '#000000', // Black
      },
    },
    typography: {
      fontFamily: 'Open Sans, sans-serif',
    },
    components: {
      // MaterialTable toolbar and selection text styling
      MuiToolbar: {
        styleOverrides: {
          root: {
            '& .MuiTypography-root': {
              color: '#000000', // Black color for selection text
            },
          },
        },
      },
      MuiTypography: {
        styleOverrides: {
          body2: {
            color: '#000000', // Black color for body text including selection count
          },
        },
      },
    },
  });

  // fetching the tableData

  const getTableData = async () => {
    setLoading(true);
    try {
      const supplierId = supplierId_WithInternal
        ? supplierId_WithInternal
        : supplierId_withForwarder;

      if (supplierId != undefined || supplierId != null) {
        const response = await allOrdersData(supplierId);
        setTableData(response.body.content[0]);
        if (response && response.body.content[0].length > 0) {
          for (let i = 0; i < response.body.content[0].length; i++) {
            const innerObj = response.body.content[0][i];
            delete innerObj.tableData;
          }

          const col = Object.keys(response.body.content[0][0]).map((key) => ({
            title: key.replace(/_/g, " ").toUpperCase(),
            field: key,
            headerStyle: {
              fontSize: "12px",
            },
          }));

          setColumns(col);

          // check whether values are all 0's and only one object is fetched from API.
          // make table data as null to show column names and 'no data found' message.
          if (response.body.content[0].length === 1) {
            let areAllZero = false;
            for (let i = 0; i < response.content[0].length; i++) {
              areAllZero = Object.values(response.content[0][i]).every(
                (value) => value === 0
              );
            }
            if (areAllZero) {
              setTableData(Array(0));
            }
          }
        }
      }
    } catch (error) {
      log("Error occured when fetching data: ", error);
      setTableData(Array(0));
    }
    setLoading(false);
  };

  //useEffects

  useEffect(() => {
    setIsInternal(userData.internal);
    // setLoading(true)
    if (!_.isEqual(previousForwarder, supplierId_WithInternal)) {
      setPreviousForwarder(supplierId_WithInternal);
    }
  });

  useEffect(() => {
    if (userData || userData.length > 0 || userData.userId) {
      if(null != userData.supplierNumber){
      getTableData();}
    }
  }, [userData]);


  useEffect(() => {
    if (previousForwarder) {
      getTableData();
    }
  }, [previousForwarder]);

  const downloadButtonFunc = (event) => {
    if (tableData) {
      handleOpenYearDialog(true);
    } else {
      toast.warn("No orders found");
    }
  };

  return (
    <div className="allOrders rounded-sm p-[5px]">
      <AllOrdersPageHeader
        supplierName={supplierName}
        isInternal={isInternal}
        setProvider={setProvider}
        providerList={providerList}
        handleTableRefresh={handleTableRefresh}
        downloadButtonFunc={downloadButtonFunc}
        isLoading={isLoading}
      />
      <div id="orderTable">
        <ThemeProvider theme={theme}>
          {isLoading && <LoaderComponent />}
          {!isLoading && (
            <AllOrdersMaterialTable
              tableName="AllOrders"
              tableRef={tableRef}
              handleOpenYearDialog={handleOpenYearDialog}
              columns={columns}
              tableData={tableData}
              exportCsv={exportCsv}
              handleTableRefresh={handleTableRefresh}
              isInternal={isInternal}
            />
          )}
          <AllOrdersDialog
            openYear={openYear}
            handleOpenYearDialog={handleOpenYearDialog}
            columns={columns}
            tableData={tableData}
            exportCsv={exportCsv}
          />
        </ThemeProvider>
      </div>
    </div>
  );
};
